var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button-group',_vm._l((_vm.periodOptions),function(unit){return _c('a-button',{key:unit.value,attrs:{"type":_vm.period === unit.value ? 'primary' : 'default'},on:{"click":function($event){return _vm.setPeriod(unit.value)}}},[_vm._v(" "+_vm._s(unit.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }